export enum ParticipantType {
  AssignedInterpreter = "assigned_interpreter",
  TransferInterpreter = "transfer_interpreter",
  VoiceCaller = "voice_caller",
  HoHUser = "hoh_user",
  Unknown = "unknown",
  HuQrUser = "hu_qr_user",
}
